import classNames from "classnames";
import React, { memo } from "react";
import {
  roundTagText,
  STATE_COLOR,
  SubmissionRoundState,
} from "v2/components/Tasks/submissionRoundStatus";

interface Props {
  roundNumber: number;
  state: SubmissionRoundState;
}

const SubmissionRoundStatusTag = ({ roundNumber, state }: Props) => {
  if (state === "none" || !roundNumber) return null;

  const text = roundTagText(roundNumber, state);
  const colorClass = STATE_COLOR[state];

  return (
    <span
      className={classNames(
        "inline-block px-2 py-0 text-11 font-semibold rounded-full whitespace-no-wrap",
        colorClass
      )}
    >
      {text}
    </span>
  );
};

export default memo(SubmissionRoundStatusTag);
